import { render, staticRenderFns } from "./profile-password-create.vue?vue&type=template&id=1c627b32"
import script from "./profile-password-create.vue?vue&type=script&lang=js"
export * from "./profile-password-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports